import { lengthOr, maxLength, minLength } from './index';

let data = {
  AF: {
    or: ['9']
  },
  AL: {
    min: '3',
    max: '9'
  },
  DZ: {
    or: ['8', '9']
  },
  AD: {
    or: ['6', '8', '9']
  },
  AO: {
    or: ['9']
  },
  AG: {
    or: ['7']
  },
  AR: {
    or: ['10']
  },
  AM: {
    or: ['8']
  },
  AU: {
    min: '4',
    max: '15'
  },
  AT: {
    min: '4',
    max: '13'
  },
  AZ: {
    min: '8',
    max: '9'
  },
  BS: {
    or: ['7']
  },
  BH: {
    or: ['8']
  },
  BD: {
    min: '6',
    max: '10'
  },
  BB: {
    or: ['7']
  },
  BY: {
    min: '9',
    max: '10'
  },
  BE: {
    min: '8',
    max: '9'
  },
  BZ: {
    or: ['7']
  },
  BJ: {
    or: ['8']
  },
  BT: {
    min: '7',
    max: '8'
  },
  BO: {
    or: ['8']
  },
  BA: {
    or: ['8']
  },
  BW: {
    min: '7',
    max: '8'
  },
  BR: {
    or: ['10']
  },
  BN: {
    or: ['7']
  },
  BG: {
    min: '7',
    max: '9'
  },
  BF: {
    or: ['8']
  },
  BI: {
    or: ['8']
  },
  CV: {
    or: ['7']
  },
  KH: {
    or: ['8']
  },
  CM: {
    or: ['8']
  },
  CA: {
    or: ['7']
  },
  CF: {
    or: ['8']
  },
  TD: {
    or: ['6', '7']
  },
  CL: {
    min: '8',
    max: '9'
  },
  CN: {
    min: '5',
    max: '12'
  },
  CO: {
    or: ['8', '10']
  },
  KM: {
    or: ['7']
  },
  CG: {
    min: '6',
    max: '7'
  },
  CR: {
    or: ['8']
  },
  CI: {
    or: ['8']
  },
  HR: {
    min: '8',
    max: '12'
  },
  CU: {
    min: '6',
    max: '8'
  },
  CY: {
    or: ['8', '11']
  },
  CZ: {
    min: '4',
    max: '12'
  },
  KP: {
    min: '3',
    max: '10'
  },
  CD: {
    min: '5',
    max: '9'
  },
  DK: {
    or: ['8']
  },
  DJ: {
    or: ['6']
  },
  DM: {
    or: ['7']
  },
  DO: {
    or: ['7']
  },
  EC: {
    or: ['8']
  },
  EG: {
    min: '7',
    max: '9'
  },
  SV: {
    or: ['7', '8', '11']
  },
  GQ: {
    or: ['6']
  },
  ER: {
    or: ['7']
  },
  EE: {
    min: '7',
    max: '10'
  },
  ET: {
    or: ['9']
  },
  FJ: {
    or: ['7']
  },
  FI: {
    min: '5',
    max: '12'
  },
  FR: {
    or: ['9']
  },
  GA: {
    or: ['6', '7']
  },
  GM: {
    or: ['7']
  },
  GE: {
    or: ['8']
  },
  DE: {
    min: '6',
    max: '13'
  },
  GH: {
    min: '5',
    max: '9'
  },
  GR: {
    or: ['10']
  },
  GD: {
    or: ['7']
  },
  GT: {
    or: ['8']
  },
  GN: {
    or: ['8']
  },
  GW: {
    or: ['7']
  },
  GY: {
    or: ['7']
  },
  HT: {
    or: ['8']
  },
  HN: {
    or: ['7', '8']
  },
  HU: {
    min: '8',
    max: '9'
  },
  IS: {
    or: ['7', '9']
  },
  IN: {
    min: '7',
    max: '10'
  },
  ID: {
    min: '5',
    max: '10'
  },
  IR: {
    min: '6',
    max: '10'
  },
  IQ: {
    min: '8',
    max: '10'
  },
  IE: {
    min: '7',
    max: '11'
  },
  IL: {
    min: '8',
    max: '9'
  },
  IT: {
    min: 'up',
    max: '11'
  },
  JM: {
    or: ['7']
  },
  JP: {
    min: '9',
    max: '10'
  },
  JO: {
    min: '5',
    max: '9'
  },
  KZ: {
    or: ['10']
  },
  KE: {
    min: '6',
    max: '10'
  },
  KI: {
    or: ['5']
  },
  KW: {
    or: ['7', '8']
  },
  KG: {
    or: ['9']
  },
  LA: {
    min: '8',
    max: '9'
  },
  LV: {
    or: ['7', '8']
  },
  LB: {
    min: '7',
    max: '8'
  },
  LS: {
    or: ['8']
  },
  LR: {
    min: '7',
    max: '8'
  },
  LY: {
    min: '8',
    max: '9'
  },
  LI: {
    min: '7',
    max: '9'
  },
  LT: {
    or: ['8']
  },
  LU: {
    min: '4',
    max: '11'
  },
  MG: {
    min: '9',
    max: '10'
  },
  MW: {
    or: ['7', '8']
  },
  MY: {
    min: '7',
    max: '9'
  },
  MV: {
    or: ['7']
  },
  ML: {
    or: ['8']
  },
  MT: {
    or: ['8']
  },
  MH: {
    or: ['7']
  },
  MR: {
    or: ['7']
  },
  MU: {
    or: ['7']
  },
  MX: {
    or: ['10']
  },
  FM: {
    or: ['7']
  },
  MC: {
    min: '5',
    max: '9'
  },
  MN: {
    min: '7',
    max: '8'
  },
  ME: {
    min: '4',
    max: '12'
  },
  MA: {
    or: ['9']
  },
  MZ: {
    min: '8',
    max: '9'
  },
  MM: {
    min: '7',
    max: '9'
  },
  NA: {
    min: '6',
    max: '10'
  },
  NR: {
    or: ['4', '7']
  },
  NP: {
    min: '8',
    max: '9'
  },
  NL: {
    or: ['9']
  },
  NZ: {
    min: '3',
    max: '10'
  },
  NI: {
    or: ['8']
  },
  NE: {
    or: ['8']
  },
  NG: {
    min: '7',
    max: '10'
  },
  NO: {
    or: ['5', '8']
  },
  OM: {
    min: '7',
    max: '8'
  },
  PK: {
    min: '8',
    max: '11'
  },
  PW: {
    or: ['7']
  },
  PA: {
    or: ['7', '8']
  },
  PG: {
    min: '4',
    max: '11'
  },
  PY: {
    min: '5',
    max: '9'
  },
  PE: {
    min: '8',
    max: '11'
  },
  PH: {
    min: '8',
    max: '10'
  },
  PL: {
    min: '6',
    max: '9'
  },
  PT: {
    or: ['9', '11']
  },
  QA: {
    or: ['6', '7', '10']
  },
  KR: {
    min: '8',
    max: '11'
  },
  MD: {
    or: ['8']
  },
  RO: {
    or: ['9']
  },
  RU: {
    or: ['10']
  },
  RW: {
    or: ['9']
  },
  KN: {
    or: ['7']
  },
  LC: {
    or: ['7']
  },
  VC: {
    or: ['7']
  },
  WS: {
    min: '3',
    max: '7'
  },
  SM: {
    min: '6',
    max: '10'
  },
  ST: {
    or: ['7']
  },
  SA: {
    min: '8',
    max: '9'
  },
  SN: {
    or: ['9']
  },
  RS: {
    min: '4',
    max: '12'
  },
  SC: {
    or: ['6']
  },
  SL: {
    or: ['8']
  },
  SG: {
    min: '8',
    max: '12'
  },
  SK: {
    min: '4',
    max: '9'
  },
  SI: {
    or: ['8']
  },
  SB: {
    or: ['5']
  },
  SO: {
    min: '5',
    max: '8'
  },
  ZA: {
    or: ['9']
  },
  ES: {
    or: ['9']
  },
  LK: {
    or: ['9']
  },
  SD: {
    or: ['9']
  },
  SR: {
    min: '6',
    max: '7'
  },
  SZ: {
    min: '7',
    max: '8'
  },
  SE: {
    min: '7',
    max: '13'
  },
  CH: {
    min: '4',
    max: '12'
  },
  SY: {
    min: '8',
    max: '10'
  },
  TJ: {
    or: ['9']
  },
  TH: {
    or: ['8', '9']
  },
  MK: {
    or: ['8']
  },
  TL: {
    or: ['7']
  },
  TG: {
    or: ['7']
  },
  TO: {
    or: ['5', '7']
  },
  TT: {
    or: ['7']
  },
  TN: {
    or: ['8']
  },
  TR: {
    or: ['10']
  },
  TM: {
    or: ['8']
  },
  TV: {
    or: ['5', '6']
  },
  UG: {
    or: ['9']
  },
  UA: {
    or: ['9']
  },
  AE: {
    min: '8',
    max: '9'
  },
  GB: {
    min: '7',
    max: '10'
  },
  TZ: {
    or: ['9']
  },
  US: {
    or: ['7']
  },
  UY: {
    min: '4',
    max: '11'
  },
  UZ: {
    or: ['9']
  },
  VU: {
    or: ['5', '7']
  },
  VE: {
    or: ['10']
  },
  VN: {
    min: '7',
    max: '10'
  },
  YE: {
    min: '6',
    max: '9'
  },
  ZM: {
    or: ['9']
  },
  ZW: {
    min: '5',
    max: '9'
  }
};

export const phone_length_by_country = (country, values) => {
  // in future if dependent field name change then
  // this function shoule get params like (dependedOn ,dependedFor , values )

  const errors = {};

  let countryCode;

  Object.keys(country).forEach((key) => {
    countryCode = country[key];
  });

  Object.keys(values).forEach((key) => {
    if (countryCode) {
      let list = data[countryCode];
      for (let v in list) {
        if (v === 'min') {
          let yoLength = parseInt(list[v], 10);
          if (minLength(yoLength)(values[key])) {
            errors[key] = minLength(list[v])(values[key]);
          }
        }

        if (v === 'max') {
          let yoLength = parseInt(list[v], 10);
          if (maxLength(yoLength)(values[key])) {
            errors[key] = maxLength(list[v])(values[key]);
          }
        }

        if (v === 'or') {
          if (lengthOr(values[key], list[v], 10)) {
            errors[key] = lengthOr(values[key], list[v]);
          }
        }
      }
    }
  });

  return errors;
};
